module.exports = __webpack_public_path__ + "static/spinner-235b9b3ed13f64542cb0792e6ae7b5c4.gif";